export const PLATFORM_LEGAL_CORPORATION_ID =
  window?._env_?.legalCorporation?.id ?? import.meta.env.VITE_PLATFORM_LEGAL_CORPORATION_ID ?? '';

export const PLATFORM_LEGAL_CORPORATION_LABEL =
  window?._env_?.legalCorporation?.label ??
  import.meta.env.VITE_PLATFORM_LEGAL_CORPORATION_LABEL ??
  '';

export const APPINSIGHT_KEY = import.meta.env.VITE_APPINSIGHT_KEY ?? '';

export const PLATFORM_LEGAL_CORPORATION_WEB_SITE =
  window?._env_?.legalCorporation?.corporateWebsiteUrl ??
  import.meta.env.VITE_PLATFORM_LEGAL_CORPORATION_WEB_SITE ??
  '';

export const PLATFORM_SITES_MAP_CENTER_LATITUDE =
  window?._env_?.sitesMap?.centerLatitude ??
  import.meta.env.VITE_PLATFORM_SITES_MAP_CENTER_LATITUDE ??
  '';

export const PLATFORM_SITES_MAP_CENTER_LONGITUDE =
  window?._env_?.sitesMap?.centerLongitude ??
  import.meta.env.VITE_PLATFORM_SITES_MAP_CENTER_LONGITUDE ??
  '';

export const CUSTOMER_AGREEMENT_VERSION = parseInt(
  window?._env_?.customerAgreementVersion ?? import.meta.env.VITE_CUSTOMER_AGREEMENT_VERSION ?? '0',
);

export const CONTACT_MAIL_ADDRESS = import.meta.env.VITE_CONTACT_MAIL_ADDRESS ?? '';
export const GDPR_MAIL_ADDRESS = 'dataprivacy@colas.com';

export const HTTP_BAD_REQUEST_STATUS_CODE = 400;
export const HTTP_NOT_FOUND_STATUS_CODE = 404;
export const HTTP_CONFLICT_STATUS_CODE = 409;
export const GOOGLE_ANALYTICS_TRACKIND_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_TRAKING_ID ?? '';

export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN ?? '';
export const DATADOG_SITE = import.meta.env.VITE_DATADOG_SITE ?? '';
export const DATADOG_ENV = import.meta.env.VITE_DATADOG_ENV ?? '';
export const DATADOG_PROJECT_SERVICE = import.meta.env.VITE_DATADOG_PROJECT_SERVICE ?? '';

export const AZURE_AD_B2C_REDIRECTION_URI =
  window?._env_?.azureAdB2C?.redirectionUri ?? import.meta.env.VITE_AUTH_AZURE_REDIRECT_URI;
export const AZURE_AD_B2C_CLIENT_ID =
  window?._env_?.azureAdB2C?.clientId ?? import.meta.env.VITE_AUTH_AZURE_CLIENT_ID;
export const AZURE_SIGN_IN_SIGN_UP_POLICY =
  window?._env_?.azureAdB2C?.signInSignUpPolicy ??
  import.meta.env.VITE_AUTH_AZURE_SIGN_IN_SIGN_UP_POLICY;
export const AZURE_TENANT_NAME =
  window?._env_?.azureAdB2C?.tenantName ?? import.meta.env.VITE_AUTH_AZURE_TENANT_NAME;
export const AZURE_BACKEND_CLIENT_ID =
  window?._env_?.azureAdB2C?.backendClientId ?? import.meta.env.VITE_AUTH_AZURE_BACKEND_CLIENT_ID;

// Project environment token (dev/test/prod), injected at deploy time from PRJ_ENV.
// Falls back to 'dev' locally where window._env_ is not substituted.
export const PRJ_ENV = import.meta.env.VITE_PRJ_ENV ?? '';

// B2C custom-policy name for the self-service password reset flow, built from the
// env token like the manual reset link: B2C_1A_<ENV>_YELLOWSTONE_PasswordReset.
// Empty when PRJ_ENV is not provided, which disables the change-password flow.
export const AZURE_PASSWORD_RESET_POLICY = PRJ_ENV
  ? `B2C_1A_${PRJ_ENV.toUpperCase()}_YELLOWSTONE_PasswordReset`
  : '';

export const PLATFORM_LEGAL_CORPORATION_LOCATION = window?._env_?.legalCorporation?.location ?? '';

export const PLATFORM_LEGAL_CORPORATION_DISTANCE_UOM = window?._env_?.distanceUOM ?? 'mile';

export const PLATFORM_LANGUAGE = window?._env_?.language ?? 'en';

export const COUNTRY = {
  US: 'US',
  CA: 'CA',
};

export const PLATFORM_COUNTRY = (window?._env_?.countryCode ?? COUNTRY.US).trim().toUpperCase();

export const IS_US_SUBSIDIARY = PLATFORM_COUNTRY === COUNTRY.US;

export const IS_SITES_MAP_BROWSER_LOCATION_FEATURE_ENABLED =
  window?._env_?.sitesMap?.useBrowserLocation ?? false;

export const LEGAL_CORPORATIONS = {
  Reeves: '170REEVES',
};

export const REPORT_TYPE = {
  Reconciliation: 'reconciliation',
  Settlement: 'settlement',
};

export const IS_GLOBALPAY_PAYMENT = window?._env_?.GlobalPay ?? false;

export const IS_TRANSIT_PAYMENT = window?._env_?.TransIT ?? false;

export const MAP_ZOOM_OUT = window?._env_?.sitesMap?.mapZoomOut ?? 0;

interface BrandLogo {
  image: string;
  url: string;
}

export const LEGAl_CORPORATION_BRAND_LOGOS_BY_ID: Record<string, BrandLogo[]> = {
  '110': [
    {
      image: 'HeaderBrandLogo.png',
      url: 'https://barrettindustries.com',
    },
    {
      image: 'BarrettPavingLogo.png',
      url: 'https://barrettpaving.com',
    },
    {
      image: 'MidlandLogo.png',
      url: 'https://midlandasphalt.com',
    },
    {
      image: 'StrawserLogo.png',
      url: 'https://strawserconstruction.com',
    },
    {
      image: 'TerryAsphaltLogo.png',
      url: 'https://terryasphalt.com',
    },
    {
      image: 'UpstoneLogo.png ',
      url: 'https://upstonematerials.com',
    },
  ],
  '210': [
    {
      image: 'HeaderBrandLogo.png',
      url: 'https://sully-miller.com',
    },
    {
      image: 'BlueDiamondLogo.png',
      url: 'https://sully-miller.com/blue-diamond/',
    },
    {
      image: 'UnitedRockLogo.png',
      url: 'https://sully-miller.com/united-rock/',
    },
  ],
  '505': [
    {
      image: 'HeaderBrandLogo.png',
      url: 'https://www.colascanada.ca',
    },
    {
      image: 'Terus-Logo.png',
      url: 'https://terusconstruction.ca',
    },
    {
      image: 'NPA-Logo.png',
      url: 'https://www.npaltd.ca',
    },
    {
      image: 'SGE-Logo.png',
      url: 'https://standardgeneraledmonton.ca',
    },
    {
      image: 'SGC-Logo.png',
      url: 'https://standardgeneralcalgary.ca',
    },
    {
      image: 'CRB-Logo.png',
      url: 'https://crbi.ca',
    },
  ],
  '190': [
    {
      image: 'HeaderBrandLogo.png',
      url: 'https://colaska.com',
    },
    {
      image: 'AggPro-Logo.png',
      url: 'https://colaska.com/qap',
    },
    {
      image: 'EmulsionProducts-Logo.png',
      url: 'http://emulsionproducts.com',
    },
    {
      image: 'ExclusivePaving-Logo.png',
      url: 'https://colaska.com/exclusive-paving',
    },
    {
      image: 'QAP-Logo.png',
      url: 'https://colaska.com/qap',
    },
    {
      image: 'Secon-Logo.png',
      url: 'https://colaska.com/secon',
    },
    {
      image: 'SoutheastRoadbuilders-Logo.png',
      url: 'https://colaska.com/serb',
    },
    {
      image: 'UniversityRedi-Mix-Logo.png',
      url: 'https://colaska.com/exclusive-paving',
    },
  ],
  '600': [
    {
      image: 'HeaderBrandLogo.png',
      url: 'https://mcasphalt.com',
    },
  ],
};

export const TRANSACTION_PAYMENT_STATUS = {
  Success: 'Success',
  Failed: 'Failed',
  InProgress: 'InProgress',
  Pending: 'Pending',
};

export const PAYMENT_MODE = {
  CreditCard: 'CreditCard',
  ACH: 'ACH',
};
